// start:ng42.barrel
import './group-detail-editor.component';
// end:ng42.barrel

